module.exports = __webpack_public_path__ + "img/28.6bf0700b.png";